<template>
  <div class="Customer">
    <Header></Header>
    <div class="wrapper">
      <div class="top">
        <p class="col-12 top-nav text-left">
          <span class="index">首页</span>
          <span>&gt;</span>
          <span class="second">客户故事</span>
        </p>
      </div>
      <div class="cont-list row">
        <div class="each col-6 col-md-3">
          <a href="/#/CustomerDetail?id=1">
            <img src="../img/customer/01.png" width="272px" height="190px" alt />
            <div class="desc">
              <p class="title">骨子里就喜欢折腾的上海女人</p>
              <p class="subtitle">尽绵薄之力，写普惠篇章</p>
              <div class="row">
                <p class="col-6 text-left time">2018-11-22</p>
                <p class="col-6 text-right more">more &gt;</p>
              </div>
            </div>
          </a>
        </div>

        <div class="each col-6 col-md-3">
          <a href="/#/CustomerDetail?id=2">
            <img src="../img/customer/02.png" width="272px" height="190px" alt />
            <div class="desc">
              <p class="title">19年，从设计师到老板，在中国做设计越来越有尊严</p>
              <p class="subtitle">创业的路很艰辛，但别怕，及时雨小贷永远在您身后！</p>
              <div class="row">
                <p class="col-6 text-left time">2019-7-23</p>
                <p class="col-6 text-right more">more &gt;</p>
              </div>
            </div>
          </a>
        </div>
        <div class="each col-6 col-md-3">
          <a href="/#/CustomerDetail?id=3">
            <img src="../img/customer/03.png" width="272px" height="190px" alt />
            <div class="desc">
              <p class="title">种梨13年，河北农民老梁的“鸭梨”</p>
              <p class="subtitle">河北种梨人—老梁的致富路！</p>
              <div class="row">
                <p class="col-6 text-left time">2018-10-12</p>
                <p class="col-6 text-right more">more &gt;</p>
              </div>
            </div>
          </a>
        </div>
        <div class="each col-6 col-md-3">
          <a href="/#/CustomerDetail?id=4">
            <img src="../img/customer/04.png" width="272px" height="190px" alt />
            <div class="desc">
              <p class="title">浙江农村小伙，白手起家的酒店梦</p>
              <p class="subtitle">从白手起家，到拥有几家连锁酒店的小伙经历了什么？</p>
              <div class="row">
                <p class="col-6 text-left time">2018-9-28</p>
                <p class="col-6 text-right more">more &gt;</p>
              </div>
            </div>
          </a>
        </div>
        <div class="each col-6 col-md-3">
          <a href="/#/CustomerDetail?id=5">
            <img src="../img/customer/05.png" width="272px" height="190px" alt />
            <div class="desc">
              <p class="title">我做时尚教育，就是想让中国有自己的服装品牌</p>
              <p class="subtitle">“时尚话语权多在欧洲，中国在时尚圈还没有话语权”</p>
              <div class="row">
                <p class="col-6 text-left time">2018-11-01</p>
                <p class="col-6 text-right more">more &gt;</p>
              </div>
            </div>
          </a>
        </div>
        <div class="each col-6 col-md-3">
          <a href="/#/CustomerDetail?id=6">
            <img src="../img/customer/06.png" width="272px" height="190px" alt />
            <div class="desc">
              <p class="title">从传统超市到连锁创新，80后超市创二代的生意经！</p>
              <p class="subtitle">开连锁超市、扩大超市经营面积，吴佟的超市越来越红火。</p>
              <div class="row">
                <p class="col-6 text-left time">2019-8-29</p>
                <p class="col-6 text-right more">more &gt;</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./Header";
import Footer from "./Footer";

export default {
  name: "customer",
  components: { Header, Footer }
};
</script>

<style scoped lang="less">
p {
  margin: 0;
}
a:hover {
  text-decoration: none;
}
.Customer {
  background: rgba(247, 247, 247, 1);
}
//pc、laptop
@media screen and (min-width: 769px) {
  .top,
  .cont-list {
    width: 1300px !important;
  }
  .title {
    font-size: 20px;
  }
  .subtitle {
    font-size: 14px;
  }
  .time {
    font-size: 12px;
  }
  .more {
    font-size: 12px;
  }
}

//phone
@media screen and (max-width: 768px) {
  .wrapper {
    padding-top: 90px;
  }
  .top {
    font-size: 26px;
  }
  .title {
    font-size: 30px;
  }
  .subtitle {
    font-size: 26px;
  }
  .time {
    font-size: 20px;
  }
  .more {
    font-size: 20px;
  }
}

.main-content {
  background: #f7f7f7;
  padding-top: 60px;
  padding-bottom: 100px;
}

.top {
  margin: 60px auto 48px;
  padding-left: 50px;
  .top-nav {
    /*font-size:20px;*/
    margin-bottom: 48px;
    .index {
      margin-right: 10px;
      color: #01a494;
    }
    .second {
      margin-left: 10px;
    }
  }
}
.cont-list {
  margin: 0 auto;
  .each {
    margin-bottom: 28px;
    img {
      width: 100% !important;
    }
    .desc {
      padding: 16px 17px 24px;
      background: #fff;
      min-height: 166px;
      .title {
        margin-bottom: 10px;
        text-align: left;
        font-weight: bold;
        min-height: 60px;
        overflow: hidden;
        color: #35383d;
      }
      .subtitle {
        color: rgba(89, 95, 103, 1);
        text-align: left;
        margin-bottom: 8px;
        min-height: 42px;
      }
      .time {
        color: rgba(89, 95, 103, 1);
      }
      .more {
        color: #01a494;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Customer.vue